import styles from "../index.module.less"
import { classModuleGenerator } from "@/utils"
import icon1 from "@/assets/images/information-icon1.png"
import icon2 from "@/assets/images/information-icon2.png"
const classnames = classModuleGenerator(styles)

function Information(props) {
  const publishList = [
    "【政策】2022年新政策表示推动中职学校就业...",
    "【动态】2022年学大职教报名常见问题解答>>",
    "【动态】2022年中职学校报名条件须知>>",
    "【动态】初中应届毕业生可通过咨询直接到校...",
  ]
  const guideList = [
    "【动态】2022年学大职教报名指南>>",
    "【动态】获取2022年中职学校招生简章>>",
    "【动态】2022年中职学校报名通知>>",
    "【动态】2022年您所在地区中职学校招生情况...",
  ]

  return (
    <section className={classnames("information-container")}>
      <h3 className={classnames("section__title")}>资讯专区</h3>
      <div className="section__inner clearfiex">
        <div className={classnames("information-left")}>
          <h5>职业教育政策</h5>
          <div className={classnames("information-left-policy")}>
            <button
              onClick={() => {
                window.openJesongChatByGroup(121, 52601)
                return false
              }}
            >
              政策咨询
            </button>
            <p>- 就业+升学双通道 -</p>
          </div>
          <h5>报名咨询指南</h5>
          <ul className={classnames("guide-btns", "clearfix")}>
            {[
              "招生简章",
              "报名时间",
              "报名条件",
              "报名费用",
              "开学规则",
              "专属咨询",
            ].map((m) => (
              <li
                key={m}
                onClick={() => {
                  window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                {m}＞
              </li>
            ))}
          </ul>
        </div>
        <div className={classnames("information-middle")}>
          <h5>职业教育政策</h5>
          <ul className={classnames("publishs")}>
            {publishList.map((m) => (
              <li
                key={m}
                onClick={() => {
                  window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                <a>{m}</a>
              </li>
            ))}
          </ul>
          <h5 style={{ marginTop: "32px" }}>2022年报名咨询解答</h5>
          <ul className={classnames("publishs")}>
            {guideList.map((m) => (
              <li
                key={m}
                onClick={() => {
                  window.openJesongChatByGroup(121, 52601)
                  return false
                }}
              >
                <a>{m}</a>
              </li>
            ))}
          </ul>
        </div>
        <div className={classnames("information-right")}>
          <div className={classnames("right-item")}>
            <img src={icon1} alt="" style={{ width: "60px", height: "32px" }} />
            <h5>校园开放日预约通道</h5>
            <p>每日前10名预约观校学生</p>
            <p>可获得专属咨询服务</p>
            <button
              onClick={() => {
                window.openJesongChatByGroup(121, 52601)
                return false
              }}
            >
              预约参观
            </button>
          </div>
          <div className={classnames("right-item")}>
            <img src={icon2} alt="" style={{ width: "34px", height: "41px" }} />
            <h5>定制2022升学方案</h5>
            <p>个性化升学方案，一对一在线规划</p>
            <button
              onClick={() => {
                window.openJesongChatByGroup(121, 52601)
                return false
              }}
            >
              立即定制
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Information
